module.exports = __webpack_public_path__ + "static/media/Udemy.bd18d6ff.png";